import { AppLoader, ErrorBoundary } from '@lm/common-ui'
import { useTranslation } from '@lm/intl'
import { Suspense, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'

import { AppRoutes } from '@/router/Routes'
import { setUser } from '@/state/slices/authSlice'
import { useDispatch } from '@/state/store'
import { getLoggedInUser } from '@/utils/auth'

const App = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    const loggedInUser = getLoggedInUser()
    if (loggedInUser) dispatch(setUser(loggedInUser))
  }, [dispatch])

  return (
    <>
      <Helmet>
        <title>{t('global.pageTitle')}</title>
      </Helmet>
      <ErrorBoundary>
        <Suspense fallback={<AppLoader />}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </ErrorBoundary>
    </>
  )
}

export default App
